/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Note attached to a claim
 * @export
 * @interface Note
 */
export interface Note {
    /**
     * 
     * @type {number}
     * @memberof Note
     */
    readonly id: number;
    /**
     * ID of the claim this note is attached to
     * @type {number}
     * @memberof Note
     */
    claimId: number;
    /**
     * Company that owns this note
     * @type {number}
     * @memberof Note
     */
    companyId: number;
    /**
     * Plaintext note content
     * @type {string}
     * @memberof Note
     */
    text: string;
    /**
     * User ID who created the note
     * @type {number}
     * @memberof Note
     */
    createdBy: number;
    /**
     * User ID who last updated the note
     * @type {number}
     * @memberof Note
     */
    updatedBy: number;
    /**
     * Display name of the user who created the note
     * @type {string}
     * @memberof Note
     */
    createdByName?: string;
    /**
     * Display name of the user who last updated the note
     * @type {string}
     * @memberof Note
     */
    updatedByName?: string;
    /**
     * 
     * @type {Date}
     * @memberof Note
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Note
     */
    readonly updatedAt: Date;
}

/**
 * Check if a given object implements the Note interface.
 */
export function instanceOfNote(value: object): value is Note {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('updatedBy' in value) || value['updatedBy'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function NoteFromJSON(json: any): Note {
    return NoteFromJSONTyped(json, false);
}

export function NoteFromJSONTyped(json: any, ignoreDiscriminator: boolean): Note {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'claimId': json['claimId'],
        'companyId': json['companyId'],
        'text': json['text'],
        'createdBy': json['createdBy'],
        'updatedBy': json['updatedBy'],
        'createdByName': json['createdByName'] == null ? undefined : json['createdByName'],
        'updatedByName': json['updatedByName'] == null ? undefined : json['updatedByName'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function NoteToJSON(json: any): Note {
    return NoteToJSONTyped(json, false);
}

export function NoteToJSONTyped(value?: Omit<Note, 'id'|'createdAt'|'updatedAt'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimId': value['claimId'],
        'companyId': value['companyId'],
        'text': value['text'],
        'createdBy': value['createdBy'],
        'updatedBy': value['updatedBy'],
        'createdByName': value['createdByName'],
        'updatedByName': value['updatedByName'],
    };
}

